const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:5001");

export function buildApiUrl(path) {
  return `${API_BASE_URL}${path}`;
}

export { API_BASE_URL };
